module.exports = __webpack_public_path__ + "node_modules/angular-i18n/angular-locale_es-es.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=.!./~/angular-i18n/angular-locale_es-es.js
// module id = 404
// module chunks = 0